export default {
  SHRINK_TO_FIT: 'shrink_to_fit',
  EXPAND_TO_FILL: 'expand_to_fill'
};
